export const apiErrorMessage = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (!detail || typeof detail !== "object") return fallback;
  const message = typeof detail.message === "string" ? detail.message : fallback;
  const names = Array.isArray(detail.clients)
    ? [...new Set(detail.clients.map(client =>
      typeof client === "string" ? client : client?.client_name || client?.name
    ).filter(Boolean))]
    : [];
  return names.length
    ? `${message} Clienti: ${names.slice(0, 5).join(", ")}${names.length > 5 ? ` e altri ${names.length - 5}` : ""}.`
    : message;
};